"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmenuMobile = void 0;
var React = require("react");
exports.SubmenuMobile = function (props) {
    var _a;
    return (React.createElement("div", { className: "l-mega-v2-mobile" },
        React.createElement("div", { className: "l-mega-v2-mobile__header" },
            React.createElement("i", { className: "fal fa-long-arrow-left", onClick: function () { return props.closeMenu(); } }),
            props.label), (_a = props.submenu) === null || _a === void 0 ? void 0 :
        _a.content));
};
